import { FC } from "react";
import { StyledCheckbox } from "./Checkbox.style";
import { AllieCheckboxProps } from "./Checkbox.types";

export const AllieCheckbox: FC<AllieCheckboxProps> = (props) => <StyledCheckbox {...props} />;
